<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="card">
            <div
              class="d-flex flex-row py-3 align-items-center justify-content-center"
            >
              <form
                id="formCharts"
                class="d-flex gap-2"
                @submit.prevent="consultaGraficas"
              >
                <div class="form-group">
                  <label for="">Fecha inicio:</label>
                  <input
                    id="fecha_inicio"
                    name="fecha_inicio"
                    type="date"
                    class="form-control"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="">Fecha fin:</label>
                  <input
                    id="fecha_fin"
                    name="fecha_fin"
                    type="date"
                    class="form-control"
                    required
                  />
                </div>
                <div class="">
                  <button
                    class="btn bg-gradient-primary mt-4 px-3 btn-sm"
                    style="margin-top: 30px !important"
                    :disabled="consultandoGraficas"
                  >
                    <span
                      class="spinner-bprder spinner-border-sm ri-search-line fs-6"
                      v-if="!consultandoGraficas"
                    ></span>
                    <span
                      v-if="consultandoGraficas"
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div
          class="d-flex justify-content-center mt-4"
          v-if="consultandoGraficas"
        >
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div class="row mt-3" v-if="showCharts">
          <div class="col-lg-6 mb-3">
            <div class="card z-index-2">
              <ChartTipoArrendamientos
                :id="'chartArrendamientos'"
                :title="'Arrendamientos'"
                :labels="chartArrendamientoData"
                :data="chartArrendamientoTotal"
              />
            </div>
          </div>
          <div class="col-lg-6 mb-3">
            <div class="card z-index-2">
              <ChartTipoArrendamientos
                :id="'chartClientes'"
                :title="'Clientes'"
                :labels="chartLineaClienteLabels"
                :data="chartLineaClienteData"
                :type="'doughnut'"
              />
            </div>
          </div>
          <div class="col-lg-6 mb-3">
            <div class="card z-index-2">
              <ChartTipoArrendamientos
                :id="'chartEstatus'"
                :title="'Estatus'"
                :labels="chartEstatusLabels"
                :data="chartEstatusData"
                :type="'doughnut'"
              />
            </div>
          </div>
          <div class="col-lg-6 mb-3">
            <div class="card z-index-2">
              <ChartTipoArrendamientos
                :id="'chartOrigen'"
                :title="'Origen'"
                :labels="chartOrigenLabels"
                :data="chartOrigenData"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import useDashboard from "@/composables/useDashboard";
import ChartTipoArrendamientos from "./components/charts/ChartTemplate.vue";

export default {
  name: "dashboard-default",
  data() {
    const {
      consultandoGraficas,
      consultaGraficas,
      chartArrendamientoData,
      chartArrendamientoTotal,
      chartLineaClienteLabels,
      chartLineaClienteData,
      chartEstatusLabels,
      chartEstatusData,
      chartOrigenLabels,
      chartOrigenData,
      showCharts,
    } = useDashboard();

    return {
      consultandoGraficas,
      consultaGraficas,
      chartArrendamientoData,
      chartArrendamientoTotal,
      chartLineaClienteLabels,
      chartLineaClienteData,
      chartEstatusLabels,
      chartEstatusData,
      chartOrigenLabels,
      chartOrigenData,
      showCharts,
    };
  },
  components: {
    ChartTipoArrendamientos,
  },
};
</script>
